// extracted by mini-css-extract-plugin
export default {"actions":"Calculation_actions__DY2jJ","syncProgress":"Calculation_syncProgress__uhgNI","syncSuccess":"Calculation_syncSuccess__KukhT","syncError":"Calculation_syncError__u7WHn"};